/**
 * Employee-wise compensation records (one SalaryStructure per employee in HR).
 */
import api from './apiClient';

export const getSalaryStructures = async (params = {}) => {
  const response = await api.get('/hr/employee-salary-structures', { params });
  return response;
};

export const getSalaryStructure = async (id) => {
  const response = await api.get(`/hr/employees/${id}/salary-structure`);
  return response;
};

export const createSalaryStructure = async () => {
  throw new Error(
    'Template salary structures are not used. Set compensation on each employee in HR → Add/Edit Employee.'
  );
};

export const updateSalaryStructure = async () => ({
  success: false,
  responseCode: 400,
  message: 'Update compensation on the employee record in HR.'
});

export const updateSalaryStructureStatus = async () => ({
  success: false,
  responseCode: 400
});

export const deleteSalaryStructure = async () => ({
  success: false,
  responseCode: 400
});
